import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { SelectModule } from "@openng/optimus-ui/select";

import {
  HardwareAdapterDirection,
  HardwareAdapterOutputIndex,
  HardwareAdapterOperation,
} from "../../../../../models/api/hardwareAdapterConfigurationDto";
import { ButlerV1ConfigurationForm, HardwareConfigurationOption } from "../hardware-configuration-form";

@Component({
  selector: "app-butler-v1-configuration-row",
  standalone: true,
  imports: [InputTextModule, ReactiveFormsModule, SelectModule, TranslateModule],
  templateUrl: "./butler-v1-configuration-row.component.html",
  styleUrl: "./butler-v1-configuration-row.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButlerV1ConfigurationRowComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  public readonly form = input.required<ButlerV1ConfigurationForm>();
  public readonly controlIdPrefix = input.required<string>();
  public readonly operationOptions = input.required<HardwareConfigurationOption<HardwareAdapterOperation>[]>();
  public readonly indexOptions = input.required<HardwareConfigurationOption<HardwareAdapterOutputIndex>[]>();

  protected readonly directionOptions: HardwareConfigurationOption<HardwareAdapterDirection>[] = [
    { label: "gate_administration.hardware_configuration.directions.output", value: "output" },
    { label: "gate_administration.hardware_configuration.directions.input", value: "input" },
  ];

  public ngOnInit(): void {
    const controls = this.form().controls;

    controls.direction.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      controls.index.reset();
      controls.operation.reset();
    });

    controls.operation.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((operation) => {
      if (operation === "door.customSignal") {
        return;
      }

      controls.label.reset("");
      controls.signalId.reset(null);
    });
  }
}
